var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_53962_6917)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.34823 0.89009C8.12003 0.828303 7.8795 0.828303 7.65131 0.89009C7.38639 0.961816 7.16336 1.13692 6.98536 1.27667L6.9356 1.31562L2.36226 4.8726C2.11118 5.06746 1.88997 5.23912 1.72513 5.46199C1.58047 5.65758 1.4727 5.87792 1.40713 6.11219C1.33241 6.37913 1.33271 6.65914 1.33305 6.97696L1.3331 11.8915C1.33309 12.243 1.33308 12.5461 1.35348 12.7959C1.37501 13.0594 1.42256 13.3216 1.55109 13.5738C1.74283 13.9501 2.0488 14.2561 2.42512 14.4479C2.67737 14.5764 2.93952 14.6239 3.20308 14.6455C3.45279 14.6659 3.75596 14.6659 4.10739 14.6658H11.8921C12.2436 14.6659 12.5467 14.6659 12.7965 14.6455C13.06 14.6239 13.3222 14.5764 13.5744 14.4479C13.9507 14.2561 14.2567 13.9501 14.4484 13.5738C14.577 13.3216 14.6245 13.0594 14.6461 12.7959C14.6665 12.5462 14.6664 12.243 14.6664 11.8916L14.6665 6.97697C14.6668 6.65914 14.6671 6.37913 14.5924 6.11219C14.5268 5.87792 14.4191 5.65758 14.2744 5.46199C14.1096 5.23912 13.8884 5.06745 13.6373 4.8726L9.06393 1.31562L9.01418 1.27667C8.83617 1.13692 8.61314 0.961817 8.34823 0.89009ZM5.33311 10.6659C4.96492 10.6659 4.66644 10.9643 4.66644 11.3325C4.66644 11.7007 4.96492 11.9992 5.33311 11.9992H10.6664C11.0346 11.9992 11.3331 11.7007 11.3331 11.3325C11.3331 10.9643 11.0346 10.6659 10.6664 10.6659H5.33311Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_53962_6917"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLine);
export default __webpack_public_path__ + "static/media/home-line.3da46c761b348a4424c980c5392fcc08.svg";
export { ForwardRef as ReactComponent };